import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserIdleComponent } from './user-idle.component';
import { CountdownModule } from 'ngx-countdown';
import { SedsModalModule } from "@serasa/shared/seds";

@NgModule({
  declarations: [ UserIdleComponent ],
  exports: [ UserIdleComponent ],
  imports: [
    CommonModule,
    CountdownModule,
    FormsModule,
    ReactiveFormsModule,
    SedsModalModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class UserIdleModule { }